import {styled, Typography} from "@mui/material";

const TextSubheading = styled(Typography)`
  font-family: Helvetica, sans-serif;
  font-weight: 500;
  font-size: 20px;
  line-height: 24px;
  color: #06326E;
`;

export default TextSubheading;
